import {
  createBaseThemeOptions,
  createUnifiedTheme,
  genPageTheme,
  palettes,
  shapes,
} from '@backstage/theme';

export const carrierDarkTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.dark,
      primary: {
        main: '#9CC9FF',
      },
      secondary: {
        main: '#BAC0D0',
      },
      error: {
        main: '#EA0029',
      },
      warning: {
        main: '#F18C1E',
      },
      info: {
        main: '#FAF0DF',
      },
      success: {
        main: '#61B549',
      },
      banner: {
        info: '#1891F6',
        error: '#EA0029',
        text: '#1891F6',
        link: '#152C73',
      },
      border: "#EA0029",
      errorBackground: '#EA0029',
      warningBackground: '#F6D009',
      infoBackground: '#152C73',
      highlight: '#EA0029',
      navigation: {
        background: 'linear-gradient(to bottom, #152C73, #000000)',
        indicator: '#BAC0D0',
        color: '#BAC0D0',
        selectedColor: '#ffffff',
        navItem: {
          hoverBackground: '#617080',
        },
      },
      stylingA: {
        background: '#4caf50',
        text: '#ffffff',
      },
      stylingB: {
        background: '#ff9800',
        text: '#ffffff',
      },
      stylingC: {
        background: '#f44336',
        text: '#ffffff',
      },
      stylingD: {
        background: '#7C4DFF',
        text: '#ffffff',
      },
      chartA: {
        pathColor: '#1abc9c',
        trailColor: '#d3d3d3',
        textColor: '#43B3AE',
      },
      pieChart: {
        background: {
          stylingA: '#43B3AE',
          stylingB: '#8DCBCB',
          stylingC: '#DFF4F4',
        },
        hover: {
          stylingA: '#3A9A96',
          stylingB: '#77B1B1',
          stylingC: '#BFE6E6',
        },
      },
    },
  }),
  defaultPageTheme: 'home',
  fontFamily: 'Arial, sans-serif',
  pageTheme: {
    home: genPageTheme({ colors: ['#152C73', '#617080'], shape: shapes.wave }),
    documentation: genPageTheme({
      colors: ['#152C73', '#617080'],
      shape: shapes.wave2,
    }),
    tool: genPageTheme({ colors: ['#212121', '#617080'], shape: shapes.round }),
    service: genPageTheme({
      colors: ['#152C73', '#617080'],
      shape: shapes.wave,
    }),
    website: genPageTheme({
      colors: ['#152C73', '#617080'],
      shape: shapes.wave,
    }),
    library: genPageTheme({
      colors: ['#152C73', '#617080'],
      shape: shapes.wave,
    }),
    other: genPageTheme({ colors: ['#152C73', '#617080'], shape: shapes.wave }),
    app: genPageTheme({ colors: ['#152C73', '#617080'], shape: shapes.wave }),
    apis: genPageTheme({ colors: ['#152C73', '#617080'], shape: shapes.wave }),
  },
});
